import { FC } from 'react'
import { Button } from 'antd'
import useAudio from 'hooks/useAudio'

import { RiPauseCircleFill, RiPlayCircleFill } from 'react-icons/ri'

interface AudioPlayerProps {
	url: string
}

const AudioPlayer: FC<AudioPlayerProps> = ({ url }) => {
	const [playing, toggle] = useAudio(url)

	return (
		<Button
			onClick={toggle}
			size='large'
			type='ghost'
			icon={playing ? <RiPauseCircleFill /> : <RiPlayCircleFill />}
		/>
	)
}

export default AudioPlayer
